<template lang="pug">
    include ../helpers/pug/mixins
    +b.rsl-notification(v-bind:class="currentClass")
        +e.inner
            +e.P.text {{ text }}
                +e.SPAN.action(
                    v-if="action"
                    v-on:click="action"
                    v-html="actionText"
                )
        +e.BUTTON.button(v-on:click="close")
            +e.SVG.icon
                use(v-bind:xlink:href="closeIcon")

</template>

<script>

export default {
    props: {
        text: {
            type: String,
            default: '',
            required: true
        },
        status: {
            type: String,
            default: '',
            required: true
        },
        autoClose: {
            type: Boolean,
            default: false
        },
        autoCloseTimeout: {
            type: Number,
            default: 3000
        },
        closeIcon: {
            type: String,
            default: '',
            required: true
        },
        action: {
            type: Function,
            default: () => {}
        },
        actionText: {
            type: String,
            default: ''
        }
    },
    computed: {
        currentClass() {
            switch (this.status) {
            case 'info': return 'rsl-notification_info';
            case 'error': return 'rsl-notification_error';
            case 'correct': return 'rsl-notification_correct';
            default: return 'rsl-notification_info';
            }
        }
    },
    created() {
        if (this.autoClose) {
            setTimeout(this.close, this.autoCloseTimeout);
        }
    },
    methods: {
        close() {
            this.$emit('close');
        }
    }
};
</script>

<style lang="sass" src="./rsl-notification.sass"></style>
